import * as React from 'react';
import PageStore from '@/stores/page';
import doLog from '@/common/log';
import './index.less';
import MyLazyComponent from '@/common/lazy-load';
import DetailIcon from '@/common/detail-icon';

interface PropsType {
  industry: {
    afterSale: { [key: string]: string };
    showroomTemplateId?: number;
  };
  language: string;
  i18n: { [key: string]: string };
  seller: {
    companyId: number;
  };
  product: {
    productId: number;
  };
}
const { useState } = React;

export default function SerVices(props: PropsType) {
  const [visible, setVisible] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const { industry, i18n, product } = props;
  const secondScreen = PageStore((state) => state.secondScreen);
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  if (!industry || Object.keys(industry).length === 0 || !industry?.afterSale?.name) return null;
  const IframeDialog = MyLazyComponent(() => import('../../common/dialog-iframe'));
  const { afterSale } = industry;
  return (
    <div className="product-ta-content" data-taplus="services">
      <p className="ta-content-left">
        <DetailIcon className={'detail-symbol'} symbol={'icon-industry-hardware-tools'} />
        <span>{i18n['detail_ta_seivicestitle']}</span>
      </p>
      <div className="ta-content-right">
        <p>
          {afterSale?.name}&nbsp;
          <span
            className="blue-font"
            onClick={() => {
              doLog('/sc.details.taService', `second=${secondScreen}`);
              setIframeUrl(afterSale?.action);
              setVisible(true);
            }}
          >
            {i18n['detail_ta_view_details']}
          </span>
        </p>
      </div>
      {isLoaded && (
        <IframeDialog
          iframeUrl={iframeUrl}
          visible={visible}
          setVisible={setVisible}
          productId={product.productId}
          action="servicesViewDetail"
          dialogClass="promotion-dialog hide-close"
        />
      )}
    </div>
  );
}
